import { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import MainLayout from '../components/layout/MainLayout'
import PostCard from '../components/social/PostCard'
import { useAuth } from '../contexts/AuthContext'
import type { Post } from '../services/socialApi'
import { getBookmarks } from '../services/socialApi'

export default function SocialSaved() {
  const [posts, setPosts] = useState<Post[]>([])
  const [loading, setLoading] = useState(true)
  const { user, isAuthenticated } = useAuth()
  const navigate = useNavigate()

  const loadSaved = useCallback(async () => {
    if (!user) {return}
    try {
      setLoading(true)
      const data = await getBookmarks(Number(user.id))
      setPosts(data)
    } catch (err) {
      console.error('Saved error:', err)
    } finally {
      setLoading(false)
    }
  }, [user])

  useEffect(() => {
    if (!isAuthenticated || !user) {
      navigate('/login')
      return
    }
    void loadSaved()
  }, [isAuthenticated, user, navigate, loadSaved])

  return (
    <MainLayout>
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '24px' }}>
        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: 'var(--text-primary)' }}>Saved Posts</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>{posts.length} saved posts</p>
        </div>
        {loading && <div style={{ textAlign: 'center', padding: '32px', color: '#667eea' }}>Loading...</div>}
        {!loading && posts.length === 0 && (
          <div style={{ textAlign: 'center', padding: '48px', color: '#64748b' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔖</div>
            <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>No saved posts</div>
            <div style={{ fontSize: '13px' }}>Bookmark posts to find them here later</div>
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {posts.map(post => <PostCard key={post.id} post={post} />)}
        </div>
      </div>
    </MainLayout>
  )
}
